module.exports = __webpack_public_path__ + "img/corner-pavilion.bb6d2578.svg";